import {Capacitor} from "@capacitor/core"
import 'cordova-plugin-purchase'
import type {App} from "vue"
import {$auth} from "@/plugins/auth"
import router from "@/router"
import route from "@/plugins/route"
import {ROUTES} from "@/router/paths"

export default {
  install(app: App) {
    app.config.globalProperties.$iap = {
      store: null,
      ProductType: null,
      Platform: null,
      storePlatform: null,
    }

    if (Capacitor.isNativePlatform()) {
      document.addEventListener('deviceready', async () => {
        const {store, ProductType, Platform} = CdvPurchase

        let platform

        const devicePlatform = Capacitor.getPlatform()
        if (devicePlatform === 'ios') {
          platform = Platform.APPLE_APPSTORE
        } else if (devicePlatform === 'android') {
          platform = Platform.GOOGLE_PLAY
        } else {
          return
        }

        store.register([
          {
            type: ProductType.PAID_SUBSCRIPTION,
            id: 'monthly',
            platform
          },
          {
            type: ProductType.PAID_SUBSCRIPTION,
            id: 'yearly',
            platform
          }
        ])

        let target: CdvPurchase.Validator.Target

        const finishPurchase = async (transaction: CdvPurchase.Transaction) => {

          target = {
            headers: {
              Authorization: "bearer " + localStorage.getItem("token"),
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            url: import.meta.env.VITE_API_BASE_URL + '/iap/validate',
          }

          store.validator = target

          await transaction.verify() // this will call our server and create the subscription record in the database

          await transaction.finish()

          // A purchase can be approved after they have left the payment page,
          // so refresh wherever they are.
          if ($auth.loggedIn) {
            await $auth.loadUser(true)
          }

          if (router.currentRoute.value.name === ROUTES.PAYMENT) {
            await router.push(route(ROUTES.PROFILE_COMPLETE))
          }
        }

        store
          .when()
          .approved(finishPurchase)

        await store.initialize([platform])

        app.config.globalProperties.$iap = {
          store,
          ProductType,
          Platform,
          storePlatform: platform,
        }
      })
    }
  }
}
